<template>
  <div>
    <div class="content-wizard">
      <div class="row mb20">
        <div class="col-lg-12">
          <h3 class="font-bold">Choisir le partenaire pour un rendez-vous le {{ getRdvDate }} :</h3>
        </div>
      </div>
      <div class="col-lg-7 col-xs-12">
        <template>
          <spinner-three-bounce class="mt20" :displayNone="!$apollo.queries.availableForSaleRdv.loading"/>

          <div v-if="!$apollo.queries.availableForSaleRdv.loading">
            <div v-for="(itemHigh, indexHighType) in filteredPartenaires"
                 :key="indexHighType"
                 class="col-lg-12 row cabinet-refresh">
              <div v-for="(item, indexType) in itemHigh"
                   :key="indexType"
                   class="col-lg-12 row cabinet-refresh">
                <div v-if="hasMoreThanOneResult(indexType)"
                     class="col-lg-1 pl0"
                     @click="refreshItem(indexType, item.index, indexHighType, -1)">
                  <div>
                    <i class="fa fa-chevron-circle-left fontSize20px cursorPointer"></i>
                  </div>
                </div>
                <div class="col-lg-10"
                     @click="selectPartenaire(item)">
                  <div class="row bg-white p-sm m-t cabinet"
                       :class="{'active': item.id === selectedPartenaireId}">
                    <a v-if="item.custom"
                       @click.prevent.stop="removePartenaire(item.id)"
                       style="position: absolute; top: 20px; left: 10px;">
                      <i class="fa fa-times"></i>
                    </a>
                    <div class="col-lg-8 col-xs-12">
                      <h4 class="font-bold">{{ item.name }} {{ displaySuffix(item.type) }}</h4>
                      <p><small>{{ addressToString(item.address) }}</small></p>
                    </div>
                    <div class="col-lg-4 text-right">
                      <small><span v-if="item.appraisalExpert" class="badge badge-success">Inspection</span>&nbsp;
                        <span class="badge" v-bind:class="getClass(indexType)">{{ item.type | capitalize }}</span></small>
                      <br><small><i class="fa fa-phone"></i> {{ item.phone }} </small>
                    </div>
                    <template>
                      <div class="col-lg-12">
                        <div class="i-checks">
                          <label>
                            <div class="iradio_square-green" style="position: relative;" :class="{'checked': item.id === selectedPartenaireId}">
                              <input type="radio" checked="" value="option2" name="a" style="position: absolute; opacity: 0;">
                              <ins class="iCheck-helper" style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                            </div>
                            <small> J’ai vérifié auprès {{ displayTypeWording(item.type) }} sa disponibilité à l’horaire proposé</small>
                          </label>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div v-if="hasMoreThanOneResult(indexType)"
                     class="col-lg-1"
                     @click="refreshItem(indexType, item.index, indexHighType, 1)">
                  <div>
                    <i class="fa fa-chevron-circle-right fontSize20px cursorPointer"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="row m-t">
          <div class="col-lg-11" style="padding:0;">
            <div class="form-group m-t"
                 :class="{'has-error': false}">
              <input type="text"
                     name="search"
                     placeholder="Chercher un autre partenaire"
                     class="form-control"
                     v-model="searchName"
                     @focus="showAutoComplete = true"
                     @blur="hideAutoComplete"
                     @keyup="searchPartenaire">
              <ul v-if="searchNameAutocomplete.length && showAutoComplete && searchName.length"
                  class="typeahead dropdown-menu"
                  style="margin-top: -10px">
                <li v-for="(partenaire, index) in searchNameAutocomplete"
                    :key="index">
                  <a class="dropdown-item d-block"
                     role="option"
                     href="#"
                     @click.prevent.stop="assignPartenaire(partenaire)">{{ partenaire.name }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <GmapMap
            ref="map"
            :center="markers.length ? markers[0] : {lat: 48.8534, lng: 2.3488}"
            :zoom="10"
            map-type-id="terrain"
            :options="{
               zoomControl: true,
               mapTypeControl: false,
               scaleControl: false,
               streetViewControl: false,
               rotateControl: false,
               fullscreenControl: true,
               disableDefaultUi: false
             }"
            style="width: 100%; height: 450px">
          <GmapMarker
              v-for="(m, index) in markers"
              :key="index"
              :position="m"
          />
        </GmapMap>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="m-t-xl">
            <label class="control-label" for="comment">Commentaire</label>
            <textarea id="comment"
                      rows="3"
                      cols="50"
                      style="width:100%"
                      v-model="expertiseComment"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <button type="button"
                class="pull-left btn btn-w-m btn-primary pull-right"
                @click="$parent.toggleBlock(2)">Précédent</button>
        <button type="button"
                class="btn btn-w-m btn-primary pull-right"
                :disabled="!selectedPartenaireId"
                @click="onSubmit">Choisir ce partenaire</button>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { addressToString } from '../../../helpers/utils'
import { formatDateFull } from '../../../helpers/filters/filter'
import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'


const FEUVERT = 'feuvert'
const AGENT = 'agent'
const RENAULT = 'concession'
const INSPECTVO = 'inspectvo'
const EASYVERIF = 'easyverif'
const ANEA = 'anea'
const BCA = 'bca'

export default {
  components: {
    SpinnerThreeBounce
  },

  props: {
    command: {
      type: Object,
      required: true
    },
    seller: {
      type: Object,
      required: true
    },

    owner: {
      type: Object,
      required: true
    },

    initialSaleRdv: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    availableForSaleRdv: [],
    partenaires: [],
    partenairesVerif: [],
    filteredPartenaires: [],
    index: {},
    gmapLoaded: false,
    markers: [],
    selectedPartenaireId: null,
    selectedAddress: null,
    expertiseComment: '',
    searchName: '',
    searchNameAutocomplete: [],
    showAutoComplete: false,
    referenceAddress: null
  }),

  computed: {
    getRdvDate () {
      if (this.initialSaleRdv.date) {
        return formatDateFull(this.initialSaleRdv.date).replace(/<br>/g, ' ')
      }
      return null
    },

    availableForSaleRdvQuery () {
      return gql`
        query {
          availableForSaleRdv(orderId:${this.command.id}) {
            referenceAddress {
              address
              zipCode
              city
            }
           availableExperts {
            experts {
              id
              name
              phone
              duration
              appraisalExpert
              address {
                address
                zipCode
                city
              }
            }
          }
         }
       }`
    },

    getExpert () {
      return gql`
        query {
          expert(id: "${this.selectedPartenaireId}") {
            id
            name
            address {
              address
              city
              zipCode
            }
            type
          }
        }`
    },

    updateSaleRdvMutation () {
      return gql`
        mutation {
          updateSaleRdv(
            saleRdvId: "${this.initialSaleRdv.id}",
            expert: "${this.selectedPartenaireId}",
            expertiseComment:"${this.expertiseComment}",
           ) {
              id
              status
              result
            }
        }
        `
    },

    expertiseSearchName () {
      return gql`
        query {
          expert (name:"${this.searchName}"){
            id,
            name
            phone
            mobile
            address {
              address
              zipCode
              city
            }
          }
        }
        `
    },
  },

  watch: {
    availableForSaleRdv () {
      this.referenceAddress = this.availableForSaleRdv.referenceAddress

      this.availableForSaleRdv.availableExperts.forEach(item => {
        this.partenaires.push(item)
      })

      if (this.partenaires[0]) {
        this.partenaires.forEach(item => {
          if (item.experts.length) this.filteredPartenaires.push({[item.type]: item.experts[0]})
        })
      }

      this.searchLocation(this.referenceAddress)
    }
  },

  mounted () {
    this.$refs.map.$mapPromise.then(() => {
      this.gmapLoaded = true
    })

    if (this.command.saleRdvExpert && this.command.saleRdvExpert.id) {
      this.selectedPartenaireId = this.command.saleRdvExpert.id
    }

    if (this.command.saleRdv.length) {
      this.selectedAddress = this.command.saleRdv[0].address
    }

    if (this.initialSaleRdv.expertiseComment) {
      this.expertiseComment = this.initialSaleRdv.expertiseComment
    }
  },

  methods: {
    displayTypeWording(type) {
      switch (type) {
        case INSPECTVO:
        case EASYVERIF:
          return "de l'inspecteur"
        case RENAULT:
          return 'de la concession'
        case BCA:
        case ANEA:
          return 'du cabinet'
        default:
          return 'du partenaire'
      }
    },

    displaySuffix(type) {
      if (type == INSPECTVO || type == EASYVERIF) {
        for (let index in this.filteredPartenaires) {
          if (this.filteredPartenaires[index].hasOwnProperty(RENAULT)) {
            return 'en concession'
          }
        }
      }

      return '';
    },

    getClass(type) {
      return 'badge-' + type
    },

    setReferenceAddress(object) {
      object.address.address = this.referenceAddress.address
      object.address.zipCode = this.referenceAddress.zipCode
      object.address.city = this.referenceAddress.city
    },

    hasMoreThanOneResult(companyType) {
      const result = this.partenaires.find(companyTypeObject => {
        if (companyTypeObject.type == companyType && companyTypeObject.companies.length > 1) {
          return true;
        }
      })

      return (result) ? true : false;
    },

    refreshItem (typeIndex, companyIndex, filteredIndex, direction) {
      const result = this.partenaires.find(item => {
        return item.type == typeIndex
      })

      let newCompanyIndex = 0
      if (direction === 1) {
        newCompanyIndex = (result.companies[companyIndex + direction] == undefined) ? 0 : companyIndex + direction;
      } else if (direction === -1) {
        newCompanyIndex = (result.companies[companyIndex + direction] == undefined) ? result.companies.length - 1 : companyIndex + direction;
      }

      this.filteredPartenaires[filteredIndex][typeIndex] = result.companies[newCompanyIndex];
      this.filteredPartenaires[filteredIndex][typeIndex]['index'] = newCompanyIndex;

      if (typeIndex == AGENT) {
        this.filteredPartenaires[filteredIndex][typeIndex].address = this.referenceAddress
      }

      if (typeIndex == RENAULT) {
        this.referenceAddress = this.filteredPartenaires[filteredIndex][typeIndex].address

        for (let index in this.filteredPartenaires) {
          if (this.filteredPartenaires[index][AGENT] != undefined) {
            this.filteredPartenaires[index][AGENT].address = this.referenceAddress
          }
        }
      }

      this.selectedAddress = this.referenceAddress
    },

    searchLocation (address) {
      let geocoder = new google.maps.Geocoder()

      geocoder.geocode({'address': addressToString(address)}, (results, status) => {
        if (status === 'OK') {
          const position = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          }

          this.markers.push(position)
        }
      })
    },

    selectPartenaire (item) {
      if (this.markers.length > 1) {
        this.markers.pop()
      }

      if (this.selectedPartenaireId === item.id) {
        this.selectedPartenaireId = null
        this.selectedAddress = null
      } else {
        this.selectedPartenaireId = item.id
        this.selectedAddress = item.address
        this.searchLocation(item.address)
      }
    },

    searchPartenaire () {
      if (this.searchName.length < 3) {
        this.searchNameAutocomplete = []
        return
      }
      this.$apollo.query({
        query: this.expertiseSearchName
      }).then((response) => {
        this.searchNameAutocomplete = response.data.expert.length > 10 ?
            response.data.expert.slice(0, 10) : response.data.expert
      })
    },

    addressToString (address) {
      return addressToString(address)
    },

    hideAutoComplete () {
      setTimeout(() => {
        this.showAutoComplete = false
      }, 100)
    },

    assignPartenaire (partenaire) {
      if (this.filteredPartenaires.length < 4) {
        partenaire.custom = true
        this.filteredPartenaires.push({['search']: partenaire})
        this.filteredPartenaires[this.filteredPartenaires.length - 1]['search']['type'] = partenaire.type

        if (partenaire.type == EASYVERIF || partenaire.type == INSPECTVO) {
          this.setReferenceAddress(this.filteredPartenaires[this.filteredPartenaires.length - 1]['search'])
        }

        this.searchName = ''
      } else {
        this.showBanner('danger', 'Le nombre maximum de partenaires a été atteint.')
      }
    },

    removePartenaire (partenaireId) {
      const partenaire = this.filteredPartenaires.find(p => p.id === partenaireId)
      const index = this.filteredPartenaires.indexOf(partenaire)
      this.filteredPartenaires.splice(index, 1)
      if (partenaireId === this.selectedPartenaireId) {
        this.selectedPartenaireId = null
      }
    },

    onSubmit () {
      this.$apollo.mutate({
        mutation: this.updateSaleRdvMutation
      }).then(() => {
        if (this.partenaires[0].experts.length > 0) {
          for (let key in this.partenaires) {
            this.partenaires[key].experts.forEach(item => {
              const result = item.id === this.selectedPartenaireId || this.searchNameAutocomplete.find(p => p.id === this.selectedPartenaireId)
              if (result) {
                this.$apollo.query({
                  query: this.getExpert,
                  fetchPolicy: 'no-cache'
                }).then(response => {
                  this.command.saleRdvExpert = response.data.expert[0]

                  if (response.data.expert.length > 0) {
                    if (response.data.expert[0].type == INSPECTVO || response.data.expert[0].type == EASYVERIF) {
                      this.command.saleRdvExpert.address = this.selectedAddress
                    }
                  }

                  let newInitialSaleRdvValue = this.initialSaleRdv
                  newInitialSaleRdvValue.expertiseComment = this.expertiseComment
                  this.$emit('update-initialSaleRdv-value', newInitialSaleRdvValue)
                }).then(() => {
                  this.showBanner('success', 'Les informations ont bien été modifiées.')
                  this.$parent.toggleBlock(4)
                })
              }
            })
          }
        } else {
          this.command.saleRdvExpert = this.filteredPartenaires[0].search
          if (this.filteredPartenaires[0].search.type == INSPECTVO || this.filteredPartenaires[0].search.type == EASYVERIF) {
            this.command.saleRdvExpert.address = this.selectedAddress
          }

          let newInitialSaleRdvValue = this.initialSaleRdv
          newInitialSaleRdvValue.expertiseComment = this.expertiseComment
          this.$emit('update-initialSaleRdv-value', newInitialSaleRdvValue)

          this.showBanner('success', 'Les informations ont bien été modifiées.')
          this.$parent.toggleBlock(4)
        }
      })
    }
  },

  apollo: {
    availableForSaleRdv: {
      query () {
        return this.availableForSaleRdvQuery
      }
    }
  }
}
</script>
